var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "vs-table__heading",
      class: {
        "vs-table__heading--sort": _vm.isSort,
        "vs-table__heading--action": _vm.isAction
      },
      on: { click: _vm.handleSortClick }
    },
    [
      _vm.isSort
        ? [
            _c("h6", [
              _c("strong", [_vm._v(_vm._s(_vm.heading.name) + " ")]),
              _vm.heading.tooltip
                ? _c("span", {
                    ref: "tooltip",
                    staticClass: "mdi mdi-help-circle"
                  })
                : _vm._e(),
              _c("div", { staticClass: "vs-table__sort" }, [
                _c("div", {
                  staticClass: "mdi mdi-chevron-up vs-table__icon",
                  class: {
                    "vs-table__icon--active":
                      _vm.sortColumn === _vm.heading.prop &&
                      _vm.sortDirection === 0
                  }
                }),
                _c("div", {
                  staticClass: "mdi mdi-chevron-down vs-table__icon",
                  class: {
                    "vs-table__icon--active":
                      _vm.sortColumn === _vm.heading.prop &&
                      _vm.sortDirection === 1
                  }
                })
              ])
            ])
          ]
        : _vm.isAction
        ? [
            _c("i", {
              class: _vm.heading.icon,
              on: { click: _vm.handleClickHeaderAction }
            })
          ]
        : _vm.isHelp
        ? [
            _c("h6", [
              _c("strong", [_vm._v(_vm._s(_vm.heading.name) + " ")]),
              _c("span", {
                staticClass: "mdi mdi-help-circle",
                on: {
                  click: function($event) {
                    return _vm.$emit("help")
                  }
                }
              })
            ])
          ]
        : _vm.isTooltip
        ? [
            _c("h6", [
              _c("strong", [_vm._v(_vm._s(_vm.heading.name))]),
              _vm.heading.tooltip
                ? _c("span", {
                    ref: "tooltip",
                    staticClass: "mdi mdi-help-circle"
                  })
                : _vm._e()
            ])
          ]
        : [_c("h6", [_c("strong", [_vm._v(_vm._s(_vm.heading))])])]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }